export enum SceneName {
	GAME = "game",
	GAME_OVER = "lose",
	MAIN_MENU = "main-menu",
}
